import { startUploadFileAws } from "./public";

const isDataImageUrl = (url) =>
  typeof url === "string" && url.startsWith("data:image/");

const persistDataImageUrlViaAwsUpload = async (dispatch, { dataUrl, path }) => {
  const blobResponse = await fetch(dataUrl);
  const blob = await blobResponse.blob();
  const mimeType = blob.type || "image/png";
  const extension = mimeType.split("/")[1] || "png";
  const file = new File([blob], `meta-ad-library-${Date.now()}.${extension}`, {
    type: mimeType,
  });

  const uploadedUrl = await dispatch(
    startUploadFileAws(file, mimeType, path, true, false)
  );

  if (uploadedUrl) {
    return {
      ok: true,
      url: uploadedUrl,
    };
  }

  return {
    ok: false,
    message: "The request could not be processed.",
  };
};

/**
 * Persists image data to storage. Data URLs are uploaded from the client via
 * generateAwsUploadUrl; remote URLs go through saveMediaInStorage.
 * @returns {Promise<{ ok: boolean, url?: string, message?: string }>}
 */
export const persistDataUrlToStorage = async (dispatch, { dataUrl, path }) => {
  if (!dataUrl) {
    return { ok: false, message: "Missing dataUrl" };
  }

  if (isDataImageUrl(dataUrl)) {
    return persistDataImageUrlViaAwsUpload(dispatch, { dataUrl, path });
  }

  const { startSaveMediaInStorage } = await import("../actions/user");

  const storageResponse = await dispatch(
    startSaveMediaInStorage({ urls: [dataUrl], path })
  );

  if (storageResponse?.ok && storageResponse.data?.urls?.[0]) {
    return {
      ok: true,
      url: storageResponse.data.urls[0],
    };
  }

  return {
    ok: false,
    message: storageResponse?.message,
  };
};
